/**
 * @generated SignedSource<<2636862162df7bb277f77643e6f5dbf2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type FilterOperator = "BEGINS_WITH" | "CONTAINS" | "EQ" | "GT" | "GTE" | "IN" | "LT" | "LTE" | "NEQ" | "NOT_CONTAINS" | "%future added value";
export type OrderByDirection = "ASC" | "DESC" | "%future added value";
export type SheetsViewMode = "ALL" | "DRAFT" | "PUBLISHED" | "%future added value";
export type DrawingSetSheetTableInput = {
  filter: DrawingSetSheetTableFilter;
  limit: number;
  orderBy?: DrawingSetSheetTableOrder | null | undefined;
  page: number;
  viewMode: SheetsViewMode;
};
export type DrawingSetSheetTableFilter = {
  drawingSetId: Filter;
  versionDate?: Filter | null | undefined;
};
export type Filter = {
  operator: FilterOperator;
  value: string;
};
export type DrawingSetSheetTableOrder = {
  createdAt?: OrderByDirection | null | undefined;
  order?: OrderByDirection | null | undefined;
  updatedAt?: OrderByDirection | null | undefined;
};
export type getDrawingSetSheetTableQuery$variables = {
  input: DrawingSetSheetTableInput;
};
export type getDrawingSetSheetTableQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"drawingSetSheetTableFragment">;
};
export type getDrawingSetSheetTableQuery = {
  response: getDrawingSetSheetTableQuery$data;
  variables: getDrawingSetSheetTableQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "getDrawingSetSheetTableQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "kind": "FragmentSpread",
        "name": "drawingSetSheetTableFragment"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "getDrawingSetSheetTableQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "DrawingSetSheetTableConnection",
        "kind": "LinkedField",
        "name": "drawingSetSheetTable",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "DrawingSetSheetEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "DrawingSetSheet",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "id",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "createdAt",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "updatedAt",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "createdById",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "versionDate",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "drawingSetId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "number",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "name",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isRemoved",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "order",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "revision",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PageTableInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "startCursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endCursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasPreviousPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "totalCount",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "limit",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "page",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "totalPages",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v1/*: any*/),
        "filters": [
          "input"
        ],
        "handle": "connection",
        "key": "drawingSetSheetTableFragment___drawingSetSheetTable",
        "kind": "LinkedHandle",
        "name": "drawingSetSheetTable"
      }
    ]
  },
  "params": {
    "cacheID": "abe5210c0832b355ff306f977e1536e9",
    "id": null,
    "metadata": {},
    "name": "getDrawingSetSheetTableQuery",
    "operationKind": "query",
    "text": "query getDrawingSetSheetTableQuery(\n  $input: DrawingSetSheetTableInput!\n) {\n  ...drawingSetSheetTableFragment_2VV6jB\n}\n\nfragment drawingSetSheetConnectionFragment on DrawingSetSheetTableConnection {\n  edges {\n    cursor\n    node {\n      ...drawingSetSheetFragment\n      id\n    }\n  }\n  pageInfo {\n    ...pageTableInfoFragment\n  }\n}\n\nfragment drawingSetSheetFragment on DrawingSetSheet {\n  id\n  createdAt\n  updatedAt\n  createdById\n  versionDate\n  drawingSetId\n  number\n  name\n  isRemoved\n  order\n  revision\n}\n\nfragment drawingSetSheetTableFragment_2VV6jB on Query {\n  drawingSetSheetTable(input: $input) {\n    edges {\n      cursor\n      node {\n        ...drawingSetSheetFragment\n        id\n        __typename\n      }\n    }\n    ...drawingSetSheetConnectionFragment\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment pageTableInfoFragment on PageTableInfo {\n  startCursor\n  endCursor\n  hasNextPage\n  hasPreviousPage\n  totalCount\n  limit\n  page\n  totalPages\n}\n"
  }
};
})();

(node as any).hash = "74d4d38b368ad5bfc48e3a1dfc2879fb";

export default node;
